import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '数据概览' }
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('@/views/Products.vue'),
        meta: { title: '商品管理' }
      },
      {
        path: 'pos',
        name: 'POS',
        component: () => import('@/views/POS.vue'),
        meta: { title: '收银台' }
      },
      {
        path: 'staff',
        name: 'StaffManage',
        component: () => import('@/views/StaffManage.vue'),
        meta: { title: '员工管理' }
      },
      {
        path: 'inventory',
        name: 'Inventory',
        component: () => import('@/views/Inventory.vue'),
        meta: { title: '仓库库存' }
      },
      {
        path: 'transactions',
        name: 'Transactions',
        component: () => import('@/views/Transactions.vue'),
        meta: { title: '交易记录' }
      },
      {
        path: 'store-customers',
        name: 'StoreCustomers',
        component: () => import('@/views/StoreCustomers.vue'),
        meta: { title: '客户管理' }
      },
      {
        path: 'store-tryon-stats',
        name: 'StoreTryonStats',
        component: () => import('@/views/StoreTryonStats.vue'),
        meta: { title: '试穿统计' }
      },
      {
        path: 'store-settings',
        name: 'StoreSettings',
        component: () => import('@/views/StoreSettings.vue'),
        meta: { title: '店铺设置' }
      },
      {
        path: 'database',
        name: 'Database',
        component: () => import('@/views/Database.vue'),
        meta: { title: '数据库查看器' }
      },
      {
        path: 'merchant-review',
        name: 'MerchantReview',
        component: () => import('@/views/MerchantReview.vue'),
        meta: { title: '店家申请审核', requiresAdmin: true }
      },
      {
        path: 'stores',
        name: 'Stores',
        component: () => import('@/views/Stores.vue'),
        meta: { title: '店家管理', requiresAdmin: true }
      },
      {
        path: 'banner-manage',
        name: 'BannerManage',
        component: () => import('@/views/BannerManage.vue'),
        meta: { title: 'Banner 管理', requiresAdmin: true }
      },
      {
        path: 'feedback',
        name: 'FeedbackManage',
        component: () => import('@/views/FeedbackManage.vue'),
        meta: { title: '用户反馈管理', requiresAdmin: true }
      },
      {
        path: 'users',
        name: 'UserManage',
        component: () => import('@/views/UserManage.vue'),
        meta: { title: '用户管理', requiresAdmin: true }
      },
      {
        path: 'tryon-history',
        name: 'TryonHistory',
        component: () => import('@/views/TryonHistory.vue'),
        meta: { title: '试穿记录管理', requiresAdmin: true }
      },
      {
        path: 'operation-logs',
        name: 'OperationLogs',
        component: () => import('@/views/OperationLogs.vue'),
        meta: { title: '操作日志', requiresAdmin: true }
      },
      {
        path: 'system-settings',
        name: 'SystemSettings',
        component: () => import('@/views/SystemSettings.vue'),
        meta: { title: '系统设置', requiresAdmin: true }
      },
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: () => import('@/views/ChangePassword.vue'),
        meta: { title: '修改密码' }
      }
    ]
  }
]
console.log(137,process.env.BASE_URL)
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 重写 push 和 replace 方法，捕获导航重定向错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message?.includes('Redirected') && !err.message?.includes('cancelled')) {
      throw err
    }
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message?.includes('Redirected') && !err.message?.includes('cancelled')) {
      throw err
    }
  })
}

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  const isAdmin = store.getters.isAdmin

  // 如果有 token，验证其有效性
  let isLoggedIn = store.getters.isLoggedIn
  if (isLoggedIn && requiresAuth) {
    const valid = await store.dispatch('verifyToken')
    isLoggedIn = valid
  }

  // 需要认证但未登录，重定向到登录页
  if (requiresAuth && !isLoggedIn) {
    next('/login')
  }
  // 已登录但访问登录页，重定向到首页
  else if (to.path === '/login' && isLoggedIn) {
    next('/')
  }
  // 需要Admin权限但当前用户不是Admin
  else if (requiresAdmin && !isAdmin) {
    next('/dashboard')
    Vue.prototype.$message.warning('您没有权限访问该页面')
  }
  // 其他情况正常放行
  else {
    next()
  }
})

export default router
